module.exports = __webpack_public_path__ + "fontawesome-webfont.svg?acf3dcb7ff752b5296ca23ba2c7c2606";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 719
// module chunks = 27